import { combineReducers } from "redux";
import employeeReducer from "./employee/reducer";
import adminReducer from "./admin/reducer";
import notificationReducer from "./notification/reducer";
const rootReducer = combineReducers({
  employeeReducer,
  adminReducer,
  notificationReducer,
});

export default rootReducer;
